
<script setup>
const props = defineProps({ blok: Object, slug: String })
const copy = computed(() => renderRichText(props.blok.copy));
</script>
<template>

		<div  class="grid lg:grid-cols-2 gap-10" >
			<div class="overflow-hidden bg-no-repeat rounded-3xl bg-cover fx-box relative">
			
				<NuxtLink :to="slug" >
					
				
					<img v-if="blok.image?.filename" 
						:width="imageDimension(blok.image.filename).width"
						:height="imageDimension(blok.image.filename).height"
					loading="lazy" class="bg-newdark-750 w-full hover:scale-110 transition duration-300 ease-in-out" :alt="blok.image.alt" :src="blok.image.filename+'/m/'" />
					<div v-else class="bg-orange-200 w-full aspect-square"></div>
					<!-- <div class="fx-box w-full h-full absolute left-0 top-0"></div> -->
				
				</NuxtLink>

				<!-- <svg class="fx" width="752" height="423" viewBox="0 0 752 423" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="1" y="1" width="750" height="421" rx="30" stroke="url(#paint0_angular_16908_112637)" stroke-width="2"/>
				<defs>
				<radialGradient id="paint0_angular_16908_112637" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(382 217) scale(431 431) rotate(0)">
					<stop offset="0.807709" stop-color="#7E1EF8"/>
					<stop offset="0.662041" stop-color="transparent"/>
		
					<animateTransform attributeName="gradientTransform"
											attributeType="XML"
											type="rotate"
											from="0 3 3"
											to="360 3 3"
											dur="10s"
											repeatCount="indefinite"/>

				</radialGradient>
				</defs>
				</svg> -->

			</div>

		<div class="md:ml-20 lg:ml-0">
			<PostCategories :blok="blok.categories" />
			<NuxtLink :to="slug" >
				<h3 class="text-4xl md:text-4xl mt-4 hover:text-primary-100 transition-colors duration-300 ease-in-out">{{ blok.title }}</h3>
			</NuxtLink>
			<div class="text-lg md:text-xl mt-4 font-light text-white/70 pointer-events-none" v-html="copy"></div>

		</div>

	</div>

	
</template>
<!-- 
<style>

.fx-box svg {
	top: 0; left: 0;
  position: absolute;
	display: block;
	width: 100%;
	height: 100%;
}

</style> -->